export function CurveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.79082 8.93831L1.5 8.21498L2.70696 7.55696L3.01903 8.25324C3.44832 9.32105 3.9826 10.3407 4.50148 11.0487C4.77342 11.4199 5.02083 11.7087 5.2508 11.8031C5.73938 12.0038 6.12223 11.8123 6.45183 11.4415C6.92254 10.912 7.30071 10.0909 7.67139 9.24487C8.18752 8.06685 8.68267 6.83966 9.26509 6.05085C9.78278 5.34971 10.3785 4.95915 11.0612 4.98325C11.2336 4.98932 12.1473 4.98491 13.0057 6.33983C13.6089 7.29182 14.0632 8.28271 14.1175 8.39725L14.4489 9.09595C14.76 9.77206 13.561 10.5683 13.2625 9.87667L12.9311 9.17797C12.881 9.07232 12.4729 8.17523 11.9166 7.29713C11.5057 6.64858 11.103 6.58613 11.0205 6.58319C10.6231 6.56917 10.3502 6.96718 10.0637 7.4449C9.64215 8.14775 9.27196 9.08214 8.87904 9.97894C8.4338 10.9952 7.95587 11.963 7.39046 12.599C6.68389 13.3939 5.85076 13.7447 4.80342 13.3146C4.41002 13.1531 3.93793 12.7295 3.4727 12.0946C2.88605 11.2941 2.27618 10.1456 1.79082 8.93831Z"
        fill="currentColor"
      />
      <path
        d="M7.05585 2.6652C7.26862 2.47279 7.60168 2.41876 7.76786 2.66512L8.09286 3.11667C8.25903 3.36303 8.15521 3.60857 7.94244 3.80099L4.20872 7.15635L2.89286 7.3082L3.4062 5.96716L7.05585 2.6652Z"
        fill="currentColor"
      />
    </svg>
  );
}
